export const TIMER_IS_COMPLETE = "TIMER_IS_COMPLETE"
